import { type FC } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import { FormProvider } from "react-hook-form";
import Modal from "@root/shared/components/Modal";
import { Label } from "@root/shared/components/Label";
import { type PresentationProps } from "./type";
import { FooterButtons } from "./uiParts/FooterButtons";
import { FormInput } from "./uiParts/FormInput";
import * as styles from "./styles.css";

const ModalTriggerButton: FC<{
  handleClick: () => void;
}> = ({ handleClick }) => (
  <div className={styles.linkBox}>
    <TextButton
      size="large"
      isBold
      className={styles.linkButton}
      leftIconName="add-more"
      onClick={handleClick}
    >
      選考期限を延長
    </TextButton>
  </div>
);

export const Presentation: FC<PresentationProps> = ({
  reasons,
  isSp,
  handleClose,
  handleRadioChange,
  handleTextAreaChange,
  methods,
  isOpen,
  onSubmit,
  selectedReason,
  handleClick,
}) => {
  return (
    <>
      <ModalTriggerButton handleClick={handleClick} />
      <FormProvider {...methods}>
        <Modal
          isShow={isOpen}
          onClose={handleClose}
          pcWidthType="small"
          headerTitle="選考期限の延長"
          footerContentStyle="button"
          spAppearanceType={isSp ? "bottom" : "center"}
          footerContent={<FooterButtons handleClose={handleClose} />}
        >
          <form onSubmit={methods.handleSubmit(onSubmit)} id="form" className={styles.form}>
            <>
              <div className={styles.head}>
                <p className={styles.headText}>
                  延長する理由をご選択ください
                  <Label theme="red" className={styles.headLabel}>
                    必須
                  </Label>
                </p>
                {methods.formState.errors.reason && (
                  <p className={styles.reasonErrorMessage}>
                    {methods.formState.errors.reason.message}
                  </p>
                )}
              </div>
              <div className={styles.itemContainer}>
                {reasons.map(({ value, text }) => (
                  <FormInput
                    key={value}
                    radioInputValue={value}
                    text={text}
                    selectedReason={selectedReason}
                    handleRadioChange={handleRadioChange}
                    handleTextAreaChange={handleTextAreaChange}
                  />
                ))}
              </div>
            </>
          </form>
        </Modal>
      </FormProvider>
    </>
  );
};
